<template>
  <div class="create_box">
    <div class="backBox" style="position: relative;">
      <img
        class="pointer"
        @click="returnBack()"
        src="@/assets/thdImg/pages/back.svg"
        alt=""
      />
      <span class="backBox_name">创建活动</span>
    </div>
    <!-- 活动条件表单设置 -->
    <div class="secondstep">
      <div class="header_tips tipBg">
        <img src="@/assets/images/new_icon_reminder.png" />
        <div>温馨提示：营销费用商家100%承担。商家承担用户下单时减免的白条息费费用(息费费用=对应期数服务费率*白条支付金额)，费用由白条侧从商家钱包扣除，或世纪留易代为扣除，账单可于京麦端或VC供应商系统查询。因官方接口限制，上传sku文件时，sku数量不能超过10个。</div>
      </div>
      <el-form ref="form" :model="formData" label-width="120px">
        <el-form-item label="活动名称：" required>
          <el-input
            v-model="formData.actBaseName"
            maxlength="50"
            show-word-limit
            placeholder="请输入活动名称"
            style="width: 400px"
          ></el-input>
        </el-form-item>
        <el-form-item label="活动时间：" required>
          <el-date-picker
            v-model="formData.startTime"
            type="datetime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            ref="timeBox"
            style="width: 200px; font-size: 12px"
            :picker-options="startTimeOption"
            default-time="00:00:00"
          >
          </el-date-picker>
          至
          <el-date-picker
            v-model="formData.finishTime"
            type="datetime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            ref="timeBox"
            style="width: 200px; font-size: 12px"
            :picker-options="finishTimeOption"
            default-time="23:59:59"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="免息期数：" required>
          <template slot="label">
            <span>免息期数<el-popover
              placement="right"
              title=""
              width="300"
              trigger="hover"
              content="用户白条付款时可享受的免息期数，普通用户免期数必须小于Plus会员。">
              <i class="el-icon-question" slot="reference"></i>
            </el-popover></span>
          </template>
          <el-checkbox-group v-model="checkList" @change="checkListChange">
            <el-checkbox v-for="item in checkListArr" :label="item" :key="item"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="PLUS规则">
          <template slot="label">
            <span>PLUS规则<el-popover
              placement="right"
              title=""
              width="300"
              trigger="hover"
              content="Plus会员可享受的免期数，Plus会员的免期数必须大于普通用户免息期数。">
              <i class="el-icon-question" slot="reference"></i>
            </el-popover></span>
          </template>
          <el-checkbox-group v-model="PLUSList" :disabled="!checkList.length">
            <el-checkbox label="6期仅限PLUS用户专享" :disabled="PLUSdisabled1"></el-checkbox>
            <el-checkbox label="12期仅限PLUS用户专享" :disabled="PLUSdisabled2"></el-checkbox>
            <el-checkbox label="24期仅限PLUS用户专享" :disabled="PLUSdisabled3"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="参与方式：" v-if="!venderType || (venderType && admittanceInfo.onlyVender)" required>
          <el-radio v-model="formData.bound" label="1">全店参与</el-radio>
          <el-radio v-model="formData.bound" label="2">部分商品参与</el-radio>
          <el-radio v-model="formData.bound" label="3">部分商品不参与</el-radio>
        </el-form-item>
        <el-form-item label="文件上传：" v-if="formData.bound != 1" required>
          <el-upload
            ref="upload"
            class="upload-demo"
            action="/jd-hd-web/iou/checkSku"
            accept=".xls, .xlsx"
            :limit="1"
            :before-upload="beforeUpload"
            :on-success="handleSuccess"
            :on-exceed="handleExceed"
            :on-remove="handleRemove"
          >
            <el-button type="primary"><i class="el-icon-upload el-icon--left"></i>上传文件</el-button>
            <span class="template_down" @click.stop="downloadTemplate">模板文件下载</span>
          </el-upload>
          <div class="checkout" v-if="uploadData.total">
            校验成功<span class="success">{{ uploadData.passNo }}</span>个sku，校验失败<span class="error">{{ uploadData.noPassNo }}</span>个。<span class="dowload_error" v-if="Number(uploadData.noPassNo)" @click="uploadError">下载失败信息</span>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="create_bottom">
      <el-button
        class="keepBtn"
        type="primary"
        size="medium"
        @click="createActivity"
        v-preventReClick
        >提 交</el-button
      >
    </div>

    <!-- 合同到期 -->
    <el-dialog
      title="提示"
      :visible.sync="createFail"
      width="420px"
      :show-close="true"
    >
      <div slot="title" class="custom_header">
        <img src="@/assets/images/tips_icon.png"/>
        <span class="title">活动创建失败提醒</span>
      </div>
      <span>活动时间超出合同有效期，当前合同截止{{ admittanceInfo.contractLastDate || "" }}，或联系采销核实</span>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="createFail = false">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 创建完成 -->
    <el-dialog
      title="提示"
      :visible.sync="finishCreate"
      width="320px"
      :show-close="true"
    >
      <div slot="title" class="custom_header">
        <i class="el-icon-success"></i>
        <span class="title">活动创建提醒</span>
      </div>
      <div style="text-align: center; font-size: 16px; margin-top: 20px;">活动已经创建成功</div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex"
import {
  getList,
  venderDetail,
  popSign,
  quit,
  checkSku,
  appendSKU,
  getDetail,
  createActivity,
  exportFailSKU,
} from "@/api/iou"

export default {
  computed: {
    ...mapState(["venderType"]),
  },

  props: {
    admittanceInfo: { // 商家白条权限信息
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      finishCreate: false, // 活动创建完成
      createFail: false, // 合同到期
      checkListLength: 0, // 免息选中长度
      checkList: [], // 免息选中list
      PLUSList: [], // PLUS选中list
      formData: {
        actBaseName: "",
        startTime: "",
        finishTime: "",
        bound: "1"
      },
      checkListArr: ["3期", "6期", "12期", "24期"],
      PLUSdisabled3: true, 
      PLUSdisabled2: true, 
      PLUSdisabled1: true, 
      uploadData: {}, // 上传的sku数据
      startTimeOption: {
        disabledDate: (time) => {
          return (new Date().getTime() - (24 * 60 * 60 * 1000)) > new Date(time).getTime() || new Date(this.formData.finishTime).getTime() < new Date(time).getTime()
        },
      },
      finishTimeOption: {
        disabledDate: (time) => {
          return new Date(this.formData.startTime).getTime() > new Date(time).getTime()
        },
      },
    }
  },

  watch: {
    checkList(val) {
      if (val.indexOf("6期") != -1 || val.indexOf("12期") != -1 || val.indexOf("24期") != -1) {
        this.PLUSdisabled1 = true
      } else {
        this.PLUSdisabled1 = false
      }
      if (val.indexOf("12期") != -1 || val.indexOf("24期") != -1) {
        this.PLUSdisabled2 = true
      } else {
        this.PLUSdisabled2 = false
      }
      if (val.indexOf("24期") != -1) {
        this.PLUSdisabled3 = true
      } else {
        this.PLUSdisabled3 = false
      }

      if (val.indexOf("6期") != -1) {
        const index = this.PLUSList.findIndex(item => item == "6期仅限PLUS用户专享")
        if (index != -1) {
          this.PLUSList.splice(index, 1)
        }
      }

      if (val.indexOf("12期") != -1) {
        const index = this.PLUSList.findIndex(item => item == "24期仅限PLUS用户专享")
        if (index != -1) {
          this.PLUSList = ["24期仅限PLUS用户专享"]
        } else {
          this.PLUSList = []
        }
      }

      if (val.indexOf("24期") != -1) {
        this.PLUSList = []
      }
    }
  },

  filters: {
    
  },

  created() {

  },

  mounted() {
    if (this.venderType && !this.admittanceInfo.onlyVender) {
      this.formData.bound = "2"
    }
  },

  methods: {
    submit() {
      this.$emit("submit")
    },

    // 创建活动
    createActivity() {
      if (this.venderType && (new Date(this.admittanceInfo.contractLastDate).getTime() < new Date().getTime())) {
        this.createFail = true
        return
      }
      
      if (!this.checkList.length) {
        return this.$message.error("请选择免息期数")
      }

      let planNum = ""
      if (this.checkList.indexOf("3期") != -1) {
        planNum = planNum + "3,"
      }
      if (this.checkList.indexOf("6期") != -1) {
        planNum = planNum + "6,"
      }
      if (this.checkList.indexOf("12期") != -1) {
        planNum = planNum + "12,"
      }
      if (this.checkList.indexOf("24期") != -1) {
        planNum = planNum + "24,"
      }
      planNum = planNum.slice(0, -1)

      let instalment = ""
      if (this.PLUSList.indexOf("6期仅限PLUS用户专享") != -1) {
        instalment = instalment + "6,"
      }
      if (this.PLUSList.indexOf("12期仅限PLUS用户专享") != -1) {
        instalment = instalment + "12,"
      }
      if (this.PLUSList.indexOf("24期仅限PLUS用户专享") != -1) {
        instalment = instalment + "24,"
      }
      instalment = !instalment ? instalment : instalment.slice(0, -1)

      if (this.formData.bound != 1 && !this.uploadData.total) {
        return this.$message.error("请上传文件")
      }

      const params = {
        ...this.formData,
        skuIds: this.formData.bound == 1 ? [] : this.uploadData.passSkus,
        planNum,
        instalment,
      }
      
      createActivity(params).then((res) => {
        if (res.code == 1) {
          this.finishCreate = true
        } else {
          this.$message.error(res.message)
        }
      })
    },

    downloadTemplate() {
      let url = "https://yeion-public.s3.cn-north-1.jdcloud-oss.com/template/sku%E4%B8%8A%E4%BC%A0%E6%A8%A1%E7%89%88.xlsx";
      let fileName= "sku上传模版.xlsx";
      let elem = document.createElement("a");
      elem.style.display = "none";
      elem.href = url;
      elem.setAttribute("download", fileName);
      document.body.appendChild(elem);
      elem.click();
    },

    // 下载错误sku信息
    uploadError() {
      exportFailSKU({ errorSkus: this.uploadData.errorSkus }).then((res) => {
        this.successMsg = "";
        this.dialogExprot = false;
        let Time = new Date().toLocaleString();
        let blob = new Blob([res.blob]);
        let link = document.createElement("a"); //a标签下载
        link.href = window.URL.createObjectURL(blob);
        link.download = "导入失败sku_" + Time + ".xlsx";
        link.click();
        window.URL.revokeObjectURL(link.href);
      })
    },

    // 免息期数改变 , 期数向下自动勾选一期
    checkListChange(val) {
      if (val.length) { 
        if (this.checkListLength > val.length) { // 当取消选中时，无需额外操作
          this.checkListLength = val.length
          return
        }
        // 判断增加的数量是否超过1个，直接查询新增的那一项的前面是否存在即可
        const index = this.checkListArr.findIndex(item => item == val[val.length - 1])
        this.checkListLength = val.length
        if (index) { 
          const str = this.checkListArr[index - 1]
          // 判断新增的前面一项是否已经选中
          const checkIndex = val.findIndex(item => item == str)
          if (checkIndex == -1) {
            this.checkList.push(str)
            this.checkListLength = this.checkList.length
          }
        }
      } else {
        this.checkListLength = 0
        this.PLUSList = []
      }
    },

    returnBack() {
      this.$emit("returnBack")
    },

    handleRemove(files, fileList) {
      this.uploadData = {}
    },

    handleExceed(files, fileList) {
      this.$message.error(`当前限制选择1个文件`);
    },

    handleSuccess(res) {
      if (res.code != 1) {
        this.$refs.upload.clearFiles()
        this.$message.error(res.message)
        return
      }
      this.uploadData = res.data
    },

    // sku文件上传大小判断
    beforeUpload(file) {
      const fileSize = file.size / 1024 / 1024 < 2;
      if (!fileSize) {
        this.message.warning("上传模板大小不能超过 2MB!");
        return  false;
      }
    },

  },
};
</script>

<style lang="scss" scoped>
.create_box {
  margin: 24px;
  background: #ffffff;
  padding-bottom: 0;
  color: #333;

  .header_tips {
    display: flex;
    padding: 10px;
    margin-left: 30px;
    margin-bottom: 30px;
    line-height: 20px;

    img {
      margin-top: 2px;
      width: 16px;
      height: 16px;
      margin-right: 10px;
    }
  }

  .secondstep {
    box-sizing: border-box;
    position: relative;
    padding: 30px 28px 30px 0;
    height: calc(100vh - 240px);
    overflow: auto;

    .upload-demo {
      width: 240px;

      .template_down {
        text-decoration: underline;
        color: #7b61ff;
        margin-left: 10px;
        transform: translateY(10px);
      }
    }

    .checkout {
      margin-top: 10px;
      color: #71c647;

      .success, .error {
        color: red;
      }

      .dowload_error {
        color: #7b61ff;
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }

  .keepBtn {
    margin-left: 30px;
    width: 188px;
    background-color: #7b61ff;
    color: #fff;
    transition: all 0.2s;
    &:hover {
      opacity: 0.9;
    }
  }

  
  .custom_header {
    display: flex;
    align-items: center;
    
    i {
      color: #4ee46b;
      font-size: 22px;
    }

    img {
      width: 22px;
      height: 22px;
    }

    .title {
      color: #333;
      font-size: 16px;
      font-weight: bold;
      margin-left: 6px;
    }
  }
}
</style>